"use strict";

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _Toolbar = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Toolbar.css") : void 0);
var _excluded = ["size", "overflowOnly", "horizontal"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var CSS_BLOCK = 'sapcnqr-toolbar';
var ToolbarSeparator = /*#__PURE__*/_react.default.forwardRef(function (_props, ref) {
  var _context;
  var addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  var props = addChildProps ? _objectSpread(_objectSpread({}, _props), addChildProps(ToolbarSeparator, _props)) : _props;
  var _props$size = props.size,
    size = _props$size === void 0 ? 'lg' : _props$size,
    overflowOnly = props.overflowOnly,
    horizontal = props.horizontal,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var classnames = _bind.default.bind(_Toolbar.default);
  return /*#__PURE__*/_react.default.createElement("span", (0, _extends2.default)({
    ref: ref,
    role: "separator"
  }, rest, {
    className: classnames("".concat(CSS_BLOCK, "__separator"), (0, _concat.default)(_context = "".concat(CSS_BLOCK, "__separator--")).call(_context, size), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__separator--horizontal"), horizontal), "".concat(CSS_BLOCK, "__separator--overflow-only"), overflowOnly))
  }));
});
ToolbarSeparator.propTypes = {
  /** Set to true to show Separator only in the overflow menu. */
  overflowOnly: _propTypes.default.bool,
  /** @ignore Set by Toolbar. */
  size: _propTypes.default.string,
  /** @ignore Set by ToolbarOverflow */
  horizontal: _propTypes.default.bool
};
ToolbarSeparator.displayName = 'ToolbarSeparator';
var _default = exports.default = ToolbarSeparator;